import React from 'react';
import useSiteConfig, { PLACEHOLDER } from '../hooks/useSiteConfig';

const McaCompliance = () => {
  const c = useSiteConfig();
  return (
    <main style={{ maxWidth: 720, margin: '0 auto', padding: '4rem 1rem' }}>
      <h1>Corporate and regulatory information</h1>
      <ul>
        <li>Operator: {c.operator_name || PLACEHOLDER}</li>
        <li>CIN: {c.operator_cin || PLACEHOLDER}</li>
        <li>Registered address: {c.operator_address || PLACEHOLDER}</li>
      </ul>
      <p>[LEGAL TEXT — TO BE PROVIDED]</p>
    </main>
  );
};

export default McaCompliance;
